import{
    SET_NEXT_PAGE,
    QUESTIONS_FETCH_REQUEST,
    QUESTIONS_FETCH_SUCCESS,
    QUESTIONS_FETCH_FAIL,
    SET_CHECKBOX_ANSWER_CHOICE,
    SET_RADIO_ANSWER_CHOICE,
    SET_TEXT_ANSWER_CHOICE,
    RESET_QUESTIONS

} from "./questionActions";

import _ from 'lodash';

const initialState = {
    loading: false,
    quizQuestionData: [],
    error: "",
    totalPages : 1,
    currentPage: 1,
    
};
const SetcheckChoice = (quizQuestionData,qnId,choice,value) => {
    let newquestiondata = _.cloneDeep(quizQuestionData);
    newquestiondata.find(qn => qn.qnId === qnId).choices.find(choiceData => choiceData.option === choice).selected = value;
    return newquestiondata;
}
const SetRadioChoice = (quizQuestionData, qnId, choice) => {
    let newquestiondata = _.cloneDeep(quizQuestionData);
    newquestiondata.choices = newquestiondata.find(qn => qn.qnId === qnId).choices.map( obj => {obj.selected = false; return obj});
    newquestiondata.find(qn => qn.qnId === qnId).choices.find(choiceData => choiceData.option === choice).selected = true;
    return newquestiondata;
}
const SetTextChoice = (quizQuestionData, qnId, value) => {
    let newquestiondata = _.cloneDeep(quizQuestionData);
    newquestiondata.find(qn => qn.qnId === qnId).value = value;
    return newquestiondata;
}
const ResetQuestionChoices = (quizQuestionData) => {
  let newquestiondata = _.cloneDeep(quizQuestionData);
     newquestiondata = newquestiondata.map(obj => {
         if(obj.choices){
             obj.choices.forEach(element => {
                 element.selected = false;
             });
         }
         if(obj.value) obj.value = "0";
         return obj;
     });
  return newquestiondata;
};
export const questionReducer = (state = initialState, action) => {
    switch (action.type) {
      case QUESTIONS_FETCH_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case QUESTIONS_FETCH_SUCCESS:
        let { totalPages, quizQuestionData } = action.payload;
        const questionData = [
          ..._.cloneDeep(state.quizQuestionData),
          ...quizQuestionData,
        ];
        return {
          ...state,
          quizQuestionData: questionData,
          totalPages: totalPages,
          error: "",
          loading: false,
        };
      case QUESTIONS_FETCH_FAIL:
        return {
          ...state,
          error: action.payload,
          loading: false,
        };
      case SET_NEXT_PAGE: {
        return {
          ...state,
          currentPage: action.payload,
        };
      }
      case SET_CHECKBOX_ANSWER_CHOICE: {
        return {
          ...state,
          quizQuestionData: SetcheckChoice(
            state.quizQuestionData,
            action.payload.questionId,
            action.payload.choice,
            action.payload.choiceValue
          ),
        };
      }
      case RESET_QUESTIONS: {
        return {
          ...state,
          quizQuestionData: ResetQuestionChoices(state.quizQuestionData),
        };
      }
      case SET_RADIO_ANSWER_CHOICE: {
        return {
          ...state,
          quizQuestionData: SetRadioChoice(
            state.quizQuestionData,
            action.payload.questionId,
            action.payload.choice
          ),
        };
      }
      case SET_TEXT_ANSWER_CHOICE: {
        return {
          ...state,
          quizQuestionData: SetTextChoice(
            state.quizQuestionData,
            action.payload.questionId,
            action.payload.value
          ),
        };
      }
      default:
        return state;
    }
};

